import { render, staticRenderFns } from "./SpaceCardWithRadio.vue?vue&type=template&id=1bb1d134&scoped=true"
import script from "./SpaceCardWithRadio.vue?vue&type=script&lang=ts"
export * from "./SpaceCardWithRadio.vue?vue&type=script&lang=ts"
import style0 from "./SpaceCardWithRadio.vue?vue&type=style&index=0&id=1bb1d134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1d134",
  null
  
)

export default component.exports